// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71717L2 5.9255V21.4999L7.5 19.2326V2.71717Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9095L11.8117 20.2747C11.2935 19.2975 11 18.183 11 16.9999C11 14.4089 12.4077 12.1467 14.5 10.9364V5.09027L9.5 2.13745V18.9095Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2.49987V11.2546C20.8662 10.4637 19.4872 9.99988 18 9.99988C17.4851 9.99988 16.9832 10.0555 16.5 10.161V4.76719L22 2.49987Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 11.4999C14.9624 11.4999 12.5 13.9623 12.5 16.9999C12.5 18.5183 13.1167 19.8947 14.1108 20.8889C15.105 21.8831 16.4814 22.4999 18 22.4999C21.0376 22.4999 23.5 20.0374 23.5 16.9999C23.5 15.4814 22.8833 14.1051 21.8892 13.1109C20.895 12.1166 19.5186 11.4999 18 11.4999ZM14.5 16.9999C14.5 15.0669 16.067 13.4999 18 13.4999C18.6032 13.4999 19.1701 13.652 19.6654 13.9205L14.9205 18.6651C14.652 18.1699 14.5 17.603 14.5 16.9999ZM16.3346 20.0793L21.0795 15.3347C21.348 15.8299 21.5 16.3968 21.5 16.9999C21.5 18.9329 19.933 20.4999 18 20.4999C17.3968 20.4999 16.8299 20.3478 16.3346 20.0793Z"}}]};

const MapBlockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-blocked-filled',
    ref,
    icon: element,
  },
));

MapBlockedFilledIcon.displayName = 'MapBlockedFilledIcon';

export default MapBlockedFilledIcon;
